module.exports = __webpack_public_path__ + "img/cirugia.d88e449d.png";